import type { Ref } from 'react';
import { useRef, useEffect, useCallback } from 'react';
import { fireworks } from '@hotjar/webapp/utils/confetti';
import {
  useGSGStore,
  selectStoreById,
} from '@hotjar/webapp/domains/activation/getting-started-guide';
import type { Site } from '@hotjar/site';
import { useGettingStartedGuide } from '@hotjar/webapp/hooks/useGettingStartedGuide';
import type { GettingStartedGuideState } from '../types';

export const useCelebrations = (
  site: Site,
  isCompleted: boolean,
): { fireworksOriginRef: Ref<HTMLDivElement> } => {
  const fireworksOriginRef = useRef<HTMLDivElement | null>(null);
  const gettingStartedGuideState = useGSGStore(
    // We use currentSite id so we don't cause re-renders if a new ref
    // to currentSite is provided with the same id
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useCallback((state) => selectStoreById(state, site), [site.id]),
  ) as GettingStartedGuideState;
  const { markAsCelebrated } = useGettingStartedGuide();

  useEffect(() => {
    if (!gettingStartedGuideState.isCelebrated && isCompleted && fireworksOriginRef.current) {
      const fireworksOriginX =
        (fireworksOriginRef.current.offsetLeft + fireworksOriginRef.current.offsetWidth / 2) /
        window.innerWidth;
      const fireworksOriginY = (fireworksOriginRef.current.offsetTop + 30) / window.innerHeight;
      fireworks(fireworksOriginX, fireworksOriginY);
      markAsCelebrated();
    }
  }, [gettingStartedGuideState, isCompleted, fireworksOriginRef, markAsCelebrated]);

  return { fireworksOriginRef };
};
